var app = angular.module("leonardo");

var SuccessDialog = function($scope, $state, $timeout) {
  $scope.uri = $scope.ngDialogData.uri;
  $scope.submit = function() {
    $timeout(function () {
      $state.go($scope.uri);
    }, 100);
    $scope.closeThisDialog();
  };
};

app.controller('SuccessDialog', ['$scope', '$state', '$timeout', SuccessDialog]);
